import React, { useState } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/payroll-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/PayrollForm';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { routes } from 'src/navigation';
import { IProvider } from '../../../../../../types/provider';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { toast } from 'react-toastify';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';

export interface StateProps {
    inProgress: boolean;
    valuesForm: any;
    providersPayroll: Paginated<Partial<IProvider>>;
}

export interface DispatchProps {
    getProvidersPayroll: (params: { dateFrom: string; dateTo: string }) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const PayrollCreateScreen: React.FunctionComponent<Props> = (props) => {
    const { inProgress, valuesForm, getProvidersPayroll, providersPayroll } = props;
    const [stateData, setStateData] = useState<any>({});
    const [findNow, setFind] = useState<boolean>(false);

    const findProviders = () => {
        const data: any = {};
        setFind(true);
        if (valuesForm.dateFrom) {
            data['dateFrom'] = changeToZeroMoment(valuesForm.dateFrom, 'YYYY-M-D');
        }
        if (valuesForm.dateTo) {
            data['dateTo'] = changeToZeroMoment(valuesForm.dateTo, 'YYYY-M-D');
        }
        if (valuesForm.dateFrom && valuesForm.dateTo) {
            getProvidersPayroll(data);
        }
        /*    if ((provider && substitutedProviderDropDown) || (seanceDateFrom && seanceDateTo)) {
            setIsFirst(true);
        }*/
    };
    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (Object.keys(stateData).length) {
            handleSubmit(e);
        } else {
            toast.error('No Sessions');
            return false;
        }
    };

    let list = providersPayroll?.list;

    list = list?.filter(function (el) {
        return (
            !(el.id == 60 && el.fullName == 'DELETED_1639148244_Outfitteщr') &&
            !(el.id == 169 && el.fullName == 'Angelina Mertsalovaa') &&
            !(el.id == 173 && el.fullName == 'Ksenia') &&
            !(el.id == 143 && el.fullName == 'Oksana')
        );
    });

    providersPayroll.list = list;

    providersPayroll.list.sort((a: Partial<IProvider>, b: Partial<IProvider>) => {
        const textA = a?.fullName ? a.fullName.toUpperCase() : '';
        const textB = b.fullName ? b.fullName.toUpperCase() : '';
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    return (
        <RoleLayout>
            {inProgress ? <Loader /> : null}
            <Breadcrumbs
                items={[
                    { name: 'PAYROLLS', path: routes.PAYROLLS_LIST },
                    { name: `GENERATE NEW`, path: '' },
                ]}
            />

            <div className={classNames(styles.wrapForm)}>
                <Form
                    handleSub={handleSub}
                    stateData={stateData}
                    setStateData={setStateData}
                    isFindProviders={findNow}
                    providersPayroll={providersPayroll}
                    findProviders={findProviders}
                    initialValues={{}}
                />
            </div>
        </RoleLayout>
    );
};

export default PayrollCreateScreen;
